import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import withAuthorization from '../components/withAuthorization';
import AvailabilityV2 from './Availability.v2';
import { getMonth } from '../utils/Utils';

class AvailabilityV2Next extends Component {

    state = {
        month: null,
        year: null,
        daysInMonth: null,
    };

    constructor(props) {
        super(props);

        const now = new Date();
        const nextMonth = new Date(now.getFullYear(), now.getMonth() + 1, 1);
        let month = getMonth(nextMonth.getMonth());
        const year = nextMonth.getFullYear();

        if (month === 13) {
          month = 1;
        }

        this.state.month = month;
        this.state.year = year;
        this.state.daysInMonth = new Date(year, month, 0).getDate();
    }

    render() {
        const {
            month,
            year,
            daysInMonth,
        } = this.state;

        return (
            <AvailabilityV2
                month={month}
                year={year}
                daysInMonth={daysInMonth}
            />
        )
    }
}

const authCondition = (authUser) => !!authUser;
export default withAuthorization(authCondition)(withRouter(AvailabilityV2Next));
